/**
 * Loading placeholder shaped like the table it stands in for (rows × columns),
 * so swapping in loaded data causes zero layout shift (UX charter R4).
 */
export function Skeleton({ rows = 5, columns = 3 }: { rows?: number; columns?: number }) {
  return (
    <div role="status" aria-busy="true" aria-label="loading" className="w-full animate-pulse">
      {Array.from({ length: rows }, (_, r) => (
        <div key={r} className="flex gap-4 border-b border-neutral-100 py-3 dark:border-neutral-800">
          {Array.from({ length: columns }, (_, c) => (
            <div key={c} className="h-4 flex-1 rounded bg-neutral-200 dark:bg-neutral-700" />
          ))}
        </div>
      ))}
    </div>
  )
}
